import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { JUZ_DATA, getJuzName } from '../data/juzData';
import CardMetaLabel from './CardMetaLabel';

const JuzList = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {JUZ_DATA.map((juz) => {
        const hovered = hoveredCard === juz.juz;
        const juzName = getJuzName(juz.juz);

        return (
          <div
            key={juz.juz}
            className="group relative"
            onMouseEnter={() => setHoveredCard(juz.juz)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <Link to={`/juz/${juz.juz}`} className="block">
              <div
                className="relative h-full p-8 rounded-2xl transition-all duration-300 cursor-pointer"
                style={{
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-default)',
                  transform: hovered ? 'translateY(-8px)' : 'translateY(0)',
                  boxShadow: hovered
                    ? '0 12px 32px rgba(0, 0, 0, 0.2), 0 0 20px rgba(212, 175, 55, 0.15)'
                    : '0 2px 8px rgba(0, 0, 0, 0.08)',
                }}
              >
                {/* Juz Number Tag */}
                <CardMetaLabel label="Juz" number={juz.juz} />

                {/* Arabic Opening Word */}
                <h2
                  className="text-arabic text-4xl font-bold mb-4 text-right"
                  style={{
                    color: hovered ? 'var(--gold-hover)' : 'var(--text-arabic)',
                    transition: 'color 300ms ease-out',
                  }}
                >
                  {juzName}
                </h2>

                {/* Surah Range */}
                <p
                  className="text-sm font-medium mb-2"
                  style={{ color: 'var(--text-english)' }}
                >
                  Surah {juz.startSurah}:{juz.startAyah} → {juz.endSurah}:{juz.endAyah}
                </p>

                {/* Surahs Count */}
                <p
                  className="text-xs"
                  style={{ color: 'var(--text-secondary)', opacity: 0.7 }}
                >
                  {juz.endSurah - juz.startSurah + 1} Surah{juz.endSurah - juz.startSurah + 1 !== 1 ? 's' : ''}
                </p>
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default JuzList;
